import { useEffect, useState } from 'react';
import AccountLayout from '../components/AccountLayout';
import AccountSupportDialog, { AccountSupportTarget } from '../components/AccountSupportDialog';
import {
  MemberCustomerServiceTicket,
  listMemberCustomerServiceTickets,
  memberCustomerServiceStatusClass,
  memberCustomerServiceStatusLabels,
} from '@/services/memberCustomerService';

export default function AccountSupport() {
  const [tickets, setTickets] = useState<MemberCustomerServiceTicket[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [supportTarget, setSupportTarget] = useState<AccountSupportTarget | null>(null);

  function load() {
    setLoading(true);
    setError('');
    listMemberCustomerServiceTickets()
      .then(setTickets)
      .catch((err) => setError(err instanceof Error ? err.message : '客服紀錄讀取失敗。'))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <AccountLayout title="客服紀錄">
      <div className="mb-4 flex flex-col gap-3 rounded-2xl border border-[#E8E0D6] bg-[#FAF8F5] p-5 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-bold text-[#1B3D2A]">需要協助嗎？</p>
          <p className="mt-1 text-sm text-[#5A6B5A]">訂單與預約建議從各自列表發問；一般會員帳號問題可在這裡建立。</p>
        </div>
        <button
          type="button"
          onClick={() => setSupportTarget({ sourceType: 'Member', sourceId: '', title: '會員帳號問題', category: 'Member' })}
          className="rounded-xl bg-[#1B3D2A] px-5 py-3 text-sm font-bold text-white hover:bg-[#143026]"
        >
          詢問會員問題
        </button>
      </div>

      {loading ? (
        <div className="rounded-2xl border border-[#E8E0D6] bg-white py-16 text-center text-sm text-[#9A8A7A]">讀取中...</div>
      ) : error ? (
        <div className="rounded-2xl border border-[#f2b8b5] bg-[#fdebea] px-4 py-3 text-sm text-[#c3423f]">{error}</div>
      ) : tickets.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-[#E8E0D6] bg-white py-16 text-center text-sm text-[#9A8A7A]">目前沒有客服紀錄。</div>
      ) : (
        <div className="grid gap-4">
          {tickets.map((ticket) => (
            <div className="rounded-2xl border border-[#E8E0D6] bg-white p-5" key={ticket.TicketId}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-bold text-[#1B3D2A]">{ticket.Subject}</p>
                  <p className="mt-1 text-xs text-[#9A8A7A]">{ticket.TicketNumber} / 更新於 {ticket.UpdatedAt || '-'}</p>
                </div>
                <span className={`rounded-full px-3 py-1 text-xs font-bold ${memberCustomerServiceStatusClass[ticket.Status]}`}>
                  {memberCustomerServiceStatusLabels[ticket.Status]}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      <AccountSupportDialog
        target={supportTarget}
        onClose={() => {
          setSupportTarget(null);
          load();
        }}
      />
    </AccountLayout>
  );
}
